/** Frame capture happens this long after the quote starts (spec constant). */
export const FRAME_CAPTURE_OFFSET_SECONDS = 0.3;

/**
 * Automatic capture point of a quote on the SOURCE-video axis:
 * `min(start + 0.3, end)`, never negative. Transcript words (and therefore
 * quote start/end), `clip.data.segments` and crop-center keyframes all live
 * on that axis — the one the editor previews (`ProjectEditor`'s
 * `currentTime` is source-video time).
 */
export function frameCaptureSourceTime(args: { start: number; end: number }): number {
  return Math.max(0, Math.min(args.start + FRAME_CAPTURE_OFFSET_SECONDS, args.end));
}
